import { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const STANDARD = { status: 'standard', trial_months: 2, offer_key: 'standard' };
export const eventQuery = code => code ? `?evento=${encodeURIComponent(code)}` : '';
export const offerDate = value => value ? new Date(value).toLocaleString('it-IT', { dateStyle: 'short', timeStyle: 'short' }) : '';

export const useHomeSmartOffer = () => {
  const { code: routeCode } = useParams();
  const [query] = useSearchParams();
  const code = routeCode || query.get('evento') || '';
  const [offer, setOffer] = useState(code ? null : STANDARD);
  const [resolvedCode, setResolvedCode] = useState(code ? null : '');
  const [loading, setLoading] = useState(Boolean(code));
  const [error, setError] = useState('');
  const [reload, setReload] = useState(0);
  const refresh = useCallback(() => setReload(v => v + 1), []);
  useEffect(() => {
    if (!code) { setOffer(STANDARD); setResolvedCode(''); setLoading(false); setError(''); return; }
    const controller = new AbortController();
    setLoading(true); setError('');
    axios.get(`${API}/api/home-smart/events/${encodeURIComponent(code)}`, { signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) { setOffer(data); setResolvedCode(code); } })
      .catch(e => { if (!controller.signal.aborted) setError('Non riusciamo a verificare l’offerta. Riprova.'); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [code, reload]);
  useEffect(() => {
    if (!code || !offer) return;
    const target = offer.status === 'active' ? offer.expires_at : offer.status === 'scheduled' ? offer.opens_at : null;
    const remaining = target ? new Date(target).getTime() - new Date(offer.server_now).getTime() : null;
    const timer = remaining !== null ? window.setTimeout(refresh, Math.min(2147483000, Math.max(0, remaining) + 100)) : null;
    const visible = () => { if (document.visibilityState === 'visible') refresh(); };
    window.addEventListener('focus', refresh); document.addEventListener('visibilitychange', visible);
    return () => { window.clearTimeout(timer); window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', visible); };
  }, [code, offer, refresh]);
  return { code, offer: offer || STANDARD, loading: loading || resolvedCode !== code, error, refresh, acceptOffer: setOffer,
    registrationPath: `/home-smart/registrazione${eventQuery(code)}` };
};